import React from "react";
import style from "./LoadingDots.module.scss";
const LoadingDots = () => {
  return <ul className={style.load_wrap} data-sentry-component="LoadingDots" data-sentry-source-file="LoadingDots.tsx">
      <li className={style.dot}></li>
      <li className={style.dot}></li>
      <li className={style.dot}></li>
      <li className={style.dot}></li>
      <li className={style.dot}></li>
    </ul>;
};
export default LoadingDots;